
import React from 'react';
import { Button } from '@/components/ui/button';
import { ChevronRight, ChevronLeft, AlertCircle } from 'lucide-react';

interface QuizNavigationProps {
  currentQuestionIndex: number;
  totalQuestions: number;
  onPrevQuestion: () => void;
  onNextQuestion: () => void;
  onSubmitQuiz: () => void;
  isSubmitting: boolean;
}

const QuizNavigation: React.FC<QuizNavigationProps> = ({
  currentQuestionIndex,
  totalQuestions,
  onPrevQuestion,
  onNextQuestion,
  onSubmitQuiz,
  isSubmitting
}) => {
  const isLastQuestion = currentQuestionIndex === totalQuestions - 1;
  
  return (
    <>
      <div className="flex justify-between pt-4">
        <Button 
          variant="outline" 
          className="text-[#0EA5E9] border-[#0EA5E9]/30 hover:bg-[#0EA5E9]/10 flex items-center gap-1"
          onClick={onPrevQuestion}
          disabled={currentQuestionIndex === 0}
        >
          <ChevronLeft className="h-4 w-4" />
          Previous
        </Button>
        
        {!isLastQuestion ? (
          <Button 
            variant="outline"
            className="text-[#0EA5E9] border-[#0EA5E9]/30 hover:bg-[#0EA5E9]/10 flex items-center gap-1"
            onClick={onNextQuestion}
          >
            Next
            <ChevronRight className="h-4 w-4" />
          </Button>
        ) : (
          <Button 
            className="bg-[#0EA5E9] text-white hover:bg-[#0EA5E9]/90"
            onClick={onSubmitQuiz}
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Submitting...' : 'Submit Quiz'}
          </Button>
        )}
      </div>

      {isLastQuestion && (
        <div className="flex items-center gap-2 bg-yellow-500/20 text-yellow-700 p-3 rounded-md mt-4 text-sm">
          <AlertCircle className="h-4 w-4" />
          <span>
            You've reached the last question. You can review your answers using the Previous button or submit your quiz.
          </span>
        </div>
      )}

      <div className="pt-4 border-t border-[#0EA5E9]/20 mt-4">
        <Button 
          variant="default"
          className="bg-[#0EA5E9] text-white hover:bg-[#0EA5E9]/90 w-full"
          onClick={onSubmitQuiz}
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Submitting...' : 'Submit Quiz'}
        </Button>
      </div>
    </>
  );
};

export default QuizNavigation;
